import { appsettingConstants } from '../_constants';
import { logoutFunction, headerForPrivateAPI, APIcallFunction } from '../_helpers';
export const appsettingActions = {
    logout,

    getAppSettingList,
    addAppSetting,
    updateAppSetting,
    deleteAppSetting,
    UpdateAppSettingStatus,getFeeSettings,updateFeeAppSetting
};

function logout() {
    logoutFunction()
    return { type: appsettingConstants.LOGOUT };
}


function getAppSettingList(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/getAppSettingList",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
            },
            (error) => {
                dispatch(failure(error));
                // dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return { type: appsettingConstants.GET_APPSETTING_LIST_REQUEST, user };
    }
    function success(user) {
        return { type: appsettingConstants.GET_APPSETTING_LIST_SUCCESS, user };
    }
    function failure(error) {
        return { type: appsettingConstants.GET_APPSETTING_LIST_FAILURE, error };
    }
}



function getFeeSettings(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/getFeeSettings",
    };
    return (dispatch) => {
        dispatch(request({ data }));
        APIcallFunction(credentials).then(
            (user) => {
                dispatch(success(user));
            },
            (error) => {
                dispatch(failure(error));
                // dispatch(alertActions.error(error));
            }
        );
    };
    function request(user) {
        return { type: appsettingConstants.GET_FEE_SETTING_LIST_REQUEST, user };
    }
    function success(user) {
        return { type: appsettingConstants.GET_FEE_SETTING_LIST_SUCCESS, user };
    }
    function failure(error) {
        return { type: appsettingConstants.GET_FEE_SETTING_LIST_FAILURE, error };
    }
}

//create
function addAppSetting(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/createAppSetting",
    };
    return APIcallFunction(credentials)
}

//update
function updateAppSetting(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/updateAppSetting",
    };
    return APIcallFunction(credentials)
}

//delete
function deleteAppSetting(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/deleteAppSetting",
    };
    return APIcallFunction(credentials)
}

function UpdateAppSettingStatus(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/updateAppSettingStatus",
    };
    return APIcallFunction(credentials)
}



function updateFeeAppSetting(data) {
    const credentials = {
        header: headerForPrivateAPI,
        method: "POST",
        body: data ?? {},
        endPoint: "/appSetting/updateAppSetting",
    };
    return APIcallFunction(credentials)
}
